import type { Asset } from "../../assets/server/digital-asset-service";
import type { UnlayerUpload } from "../types/unlayer-upload";

const PER_PAGE = 20;

type UserUploadsDone = (
  images: UnlayerUpload[],
  pagination: { hasMore: boolean; total: number; page: number; perPage: number },
) => void;

// Unlayer waits on done() for every request, so it must be called even when loading assets fails.
export function createUserUploadsProvider(
  getImageAssets: () => Promise<Asset[] | undefined>,
): (params: { page: number; searchText: string }, done: UserUploadsDone) => void {
  return (params, done) => {
    const search = params.searchText.trim().toLowerCase();
    const page = params.page || 1;

    const respond = (images: UnlayerUpload[]): void => {
      const total = images.length;
      done(images.slice((page - 1) * PER_PAGE, page * PER_PAGE), {
        hasMore: total > page * PER_PAGE,
        total,
        page,
        perPage: PER_PAGE,
      });
    };

    void (async () => {
      let contentLibraryAssets: Asset[] | undefined;
      try {
        contentLibraryAssets = await getImageAssets();
      } catch (error) {
        console.error("Failed to load image assets", error);
      }
      const images = (contentLibraryAssets ?? [])
        .filter(
          (x) =>
            !search ||
            x.title.trim().toLowerCase().includes(search) ||
            x.content_type?.trim().toLowerCase().includes(search),
        )
        .map((asset) => ({
          id: asset.id,
          location: asset.public_url,
          contentType: asset.mime_type,
          source: "user",
          // oxlint-disable-next-line typescript/no-unsafe-type-assertion
        })) as UnlayerUpload[];
      respond(images);
    })();
  };
}
